export default "__VITE_ASSET__By4TLdew__"